export default __webpack_public_path__ + "static/media/antonio-barbero-hijo.3a24cb57.webp";